import TextBubbles from '@/pages/home/components/TextBubbles';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { channelInfo } from '@/pages/opinion/components/ChannelLabel';
import { excludeChannels } from '@/pages/opinion/constants';
import { getCompetitorMention } from '@/pages/opinion/services';
import {
  arrayToObj,
  getPercentageValue,
  transRegion,
} from '@/pages/opinion/utils';
import { percentageFormat, reviewsFormat } from '@/pages/opinion/utils/value';
import { mergeExcludeChannel } from '@op/components/FilterCommon/utils';
import React, { useEffect, useState } from 'react';
import { Progress } from 'tea-component';
import { useIntl } from 'umi';

export default function ChannelRow({
  isShadow,
  games,
  filter,
  isCache,
}: {
  isCache: boolean;
  isShadow: boolean;
  games: Array<any>;
  filter: any;
}) {
  const [mentionDistribution, setMentionDistribution] = useState<any>({});
  const [mentionLoading, setMentionLoading] = useState(true);

  const getListTotal = (list: Array<any>) => {
    return list?.reduce((pre: any, cur: any) => pre + cur.mentions, 0) || 0;
  };

  const getTopThreeList = (
    list: Array<any>,
    total: number,
    nameKey: string,
  ) => {
    return list
      ?.map((item: any) => {
        let value = item.mentions;
        let name = item[nameKey];
        return { value, percent: getPercentageValue(value, total), name };
      })
      .sort((a: any, b: any) => b.value - a.value)
      .slice(0, 3);
  };

  const getTableMention = async () => {
    setMentionLoading(true);
    let data: any = await getCompetitorMention(
      mergeExcludeChannel(
        {
          ...filter,
          games,
          metrics: ['language', 'channel', 'region', 'country'],
        },
        excludeChannels,
      ),
    );

    let dataObj = arrayToObj(
      data || [],
      (item) => item?.game?.edition_unified_id,
    );
    let dataMap = games.reduce((preObj, { edition_unified_id }) => {
      let { value } = dataObj[edition_unified_id] || {};
      let { channel_list, country_list, language_list, region_list } =
        value || {};
      const channelTotal = getListTotal(channel_list);
      const countryTotal = getListTotal(country_list);
      const languageTotal = getListTotal(language_list);
      const regionTotal = getListTotal(region_list);
      return {
        ...preObj,
        [edition_unified_id]: {
          Channel: getTopThreeList(channel_list, channelTotal, 'channel'),
          Region: getTopThreeList(region_list, regionTotal, 'region'),
          Country: getTopThreeList(country_list, countryTotal, 'country'),
          Language: getTopThreeList(language_list, languageTotal, 'language'),
        },
      };
    }, {});
    setMentionDistribution(dataMap);
    setMentionLoading(false);
  };

  useEffect(() => {
    if (games.length > 0 && filter && !isCache) {
      getTableMention();
    }
  }, [games, isCache]);

  const renderList = [
    {
      key: 'Channel',
      color: '#5086F3',
      formateData: (value: any) => {
        let { name } = channelInfo(value);
        return name;
      },
    },
    {
      key: 'Region',
      color: '#69D19C',
      formateData: (value: string) => {
        let realValue = transRegion(value, 1);
        return realValue?.toLowerCase() === 'global'
          ? formatMessage({ id: 'Unidentified' })
          : realValue;
      },
    },
    {
      key: 'Country',
      color: '#6E7794',
      formateData: (value: string) => {
        let realValue = transRegion(value, 2);
        return realValue?.toLowerCase() === 'global'
          ? formatMessage({ id: 'Unidentified' })
          : realValue;
      },
    },
    {
      key: 'Language',
      color: '#F8D74D',
      formateData: (value: string) => transRegion(value, 3),
    },
  ];

  const { formatMessage } = useIntl();

  return (
    <CardCommon contentCard loading={mentionLoading} loadingHeight={300}>
      <>
        {renderList.map(({ key, color, formateData }) => {
          return (
            <div className="table-context-item" key={key}>
              <div className="first-col table-item text-name">
                {formatMessage({ id: key })}
              </div>
              {games.map(({ edition_unified_id }: any, i: number) => {
                const data =
                  mentionDistribution?.[edition_unified_id]?.[key] || [];
                return (
                  <div
                    className={`col-padding ${
                      i == 0 && isShadow ? 'sticky-text' : ''
                    }`}
                    key={edition_unified_id}
                  >
                    {data?.length ? (
                      <TableRow2
                        color={color}
                        formateData={formateData}
                        data={data}
                        type={key}
                      />
                    ) : (
                      <div className="no-data-style">
                        {formatMessage({ id: 'No data' })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </>
    </CardCommon>
  );
}

// Channel模块局部展示数据
const TableRow2 = (props: any) => {
  let { data, color, formateData } = props;
  return data.map(({ name, value, percent }: any) => {
    return (
      <div className="dbo-progress" key={name}>
        <TextBubbles className="progress-title" text={formateData(name)} />
        {/* <span className="progress-title">{formateData(name)}</span> */}
        <Progress
          className="progress-style"
          percent={percent * 100}
          strokeColor={color}
        />
        <span className="progress-num">{reviewsFormat(value)}</span>
        <span className="progress-text">
          {percentageFormat(percent * 100, '0%', 0)}
        </span>
      </div>
    );
  });
};
